import React, { Component } from "react";
import { parseCurrencyPairString, sumXTradesFee, sumXTradesTotal } from "../utils/botUtils";
import { VictoryAxis, VictoryBar, VictoryChart, VictoryGroup, VictoryLabel, VictoryTheme } from "victory";

export default class TradesBarChart extends Component {
  sumTradeProfitPct(trade) {
    const openTotal = sumXTradesTotal(trade.openXTradeList);
    const closeTotal = sumXTradesTotal(trade.closeXTradeList);
    const closeFee = sumXTradesFee(trade.closeXTradeList);

    if (!openTotal || !closeTotal) {
      return 0;
    }

    return (closeTotal - openTotal - closeFee) / openTotal * 100;
  }

  prepareBarData(trades) {
    const dataByCurrency = trades.reduce((rv, t) => {
      const base = parseCurrencyPairString(t["currencyPair"]).base;
      let value = rv[base];

      const ret = this.sumTradeProfitPct(t);

      if (value) {
        value.profit += ret > 0 ? ret : 0;
        value.profitCnt += ret > 0 ? 1 : 0;
        value.loss += ret <= 0 ? ret : 0;
        value.lossCnt += ret <= 0 ? 1 : 0;
        value.overall += ret;
      } else {
        value = {
          profit: ret > 0 ? ret : 0,
          profitCnt: ret > 0 ? 1 : 0,
          loss: ret <= 0 ? ret : 0,
          lossCnt: ret <= 0 ? 1 : 0,
          overall: ret,
        };
      }

      rv[base] = value;
      return rv;
    }, {});

    const overall = [],
      profit = [],
      loss = [];

    Object.keys(dataByCurrency).forEach(key => {
      overall.push({
        currency: key,
        value: dataByCurrency[key].overall,
      });
    });

    overall.sort((a, b) => a.value - b.value);

    let min = 0,
      max = 0;

    for (let i = 0; i < overall.length; ++i) {
      overall[i].rank = i + 1;

      const key = overall[i].currency;
      const currData = dataByCurrency[key];

      profit.push({
        rank: i + 1,
        value: currData.profit,
        label: currData.profitCnt > 0 ? key + " " + currData.profit.toFixed(1) + " (" + currData.profitCnt + ")" : "",
      });
      loss.push({
        rank: i + 1,
        value: currData.loss,
        label: currData.lossCnt > 0 ? currData.loss.toFixed(1) + " (" + currData.lossCnt + ") " + key : "",
      });

      min = Math.min(min, currData.loss);
      max = Math.max(max, currData.profit);
    }

    return {
      overall,
      profit,
      loss,
      min,
      max,
    };
  }

  render() {
    if (!this.props.trades) {
      return null;
    }

    const data = this.prepareBarData(this.props.trades);

    if (data.overall.length === 0) {
      return null;
    }

    return (
      <VictoryChart width={1400} height={600} domainPadding={20} theme={VictoryTheme.material}>
        <VictoryAxis crossAxis tickValues={data.overall.map(e => e.currency)} tickFormat={c => ""} standalone={false} />
        <VictoryAxis
          dependentAxis
          crossAxis
          domain={[data.min + data.min / 3, data.max + data.max / 3] /* min and max with some padding */}
          standalone={false}
        />
        <VictoryGroup offset={0} style={{ data: { width: 12 } }} colorScale={["#69D95C", "#f13966", "black"]}>
          <VictoryBar
            data={data.profit}
            x="rank"
            y="value"
            labelComponent={<VictoryLabel angle={90} verticalAnchor="middle" textAnchor="end" />}
          />
          <VictoryBar
            data={data.loss}
            x="rank"
            y="value"
            labelComponent={<VictoryLabel angle={90} verticalAnchor="middle" textAnchor="start" />}
          />
          <VictoryBar
            data={data.overall}
            x="rank"
            y="value"
            labelComponent={<VictoryLabel angle={90} verticalAnchor="middle" textAnchor="end" />}
          />
        </VictoryGroup>
      </VictoryChart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/trade/TradesBarChart.js